
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
  <path
    d="M3.71804 13.1521H17.432C17.8286 13.1521 18.15 12.8306 18.15 12.4341C18.1501 12.2148 18.0497 12.0076 17.8775 11.8717C17.834 11.8161 17.7826 11.7672 17.7249 11.7266L12.6019 8.13145C12.392 7.98324 12.1188 7.95853 11.8857 8.06665C11.6526 8.17478 11.495 8.39926 11.4726 8.65526C11.4501 8.91125 11.5662 9.15973 11.7769 9.30679L15.2099 11.716H3.71804C3.32148 11.716 3 12.0375 3 12.434C3 12.8306 3.32148 13.1521 3.71804 13.1521V13.1521Z"
    fill="currentColor"
  />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'GoTo',
    }) as DefineComponent
    </script>
    